import { render, staticRenderFns } from "./EditPageDialog.vue?vue&type=template&id=25209716&"
import script from "./EditPageDialog.vue?vue&type=script&lang=js&"
export * from "./EditPageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports